
import { buildPublisherNode, toJsonLd } from '@/utils/seo'

export default {
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'blogposting-structured-data',
          innerHTML: toJsonLd(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: this.article.title,
        description:
          this.article.subtitle ||
          this.stripHTML(this.article.body).substring(0, 155),
        articleBody: this.stripHTML(this.article.body),
        inLanguage: this.$i18n.locale,
        datePublished: this.article.created_at,
        dateModified: this.article.updated_at || this.article.created_at,
        author: {
          '@type': 'Organization',
          name: 'AGM Vision',
          url: this.$config.url,
          sameAs: this.brandProfiles,
        },
        publisher: {
          ...buildPublisherNode(this.$config.url),
          sameAs: this.brandProfiles,
        },
        image: this.getArticleImages(),
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': this.getUrl(),
        },
        keywords: this.article.meta_keywords || '',
        articleSection: 'LED et accessoires véhicules',
        wordCount: this.getWordCount(),
      }
    },
    brandProfiles() {
      return [
        'https://www.facebook.com/agmvision/',
        'https://www.instagram.com/agm_vision/',
        'https://www.tiktok.com/@agmvision',
        'https://www.youtube.com/@agmvision',
      ]
    },
  },
  methods: {
    getUrl() {
      return this.$config.url + this.$route.path
    },

    stripHTML(content) {
      if (!content) return ''
      return content.replace(/<\/?[^>]+(>|$)/g, '')
    },

    getArticleImages() {
      const images = []

      if (this.article.images?.length) {
        this.article.images.forEach(image => {
          images.push({
            '@type': 'ImageObject',
            url: image.url,
            caption: image.alt || this.article.title,
          })
        })
      }

      // Image par défaut si aucune image
      if (images.length === 0) {
        images.push({
          '@type': 'ImageObject',
          url: `${this.$config.url}/logo_og.png`,
          caption: 'AGM Vision - Articles LED',
        })
      }

      return images
    },

    getWordCount() {
      if (!this.article.body) return 0
      const text = this.stripHTML(this.article.body)
      return text.split(/\s+/).filter(word => word.length > 0).length
    },
  },
}
